import { createContext } from 'react'

import { AuthenticatedUser, User } from '~/hooks/useAuthentication/types'

export const AuthenticatedUserContext = createContext<
  Readonly<[User, AuthenticatedUser[1], AuthenticatedUser[2]]>
>([
  null,
  (() => Promise.resolve({} as never)) as AuthenticatedUser[1],
  {
    loading: false,
    refetch: (() => Promise.resolve({} as never)) as AuthenticatedUser[2]['refetch'],
  },
])
